import { render, staticRenderFns } from "./followUp.vue?vue&type=template&id=64eeadc2&scoped=true&"
import script from "./followUp.vue?vue&type=script&lang=js&"
export * from "./followUp.vue?vue&type=script&lang=js&"
import style0 from "./followUp.vue?vue&type=style&index=0&id=64eeadc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eeadc2",
  null
  
)

export default component.exports